import {useMemo} from "react";
import { Navigate, Outlet } from "react-router-dom";
import {getUserRole} from "./service/api/apiClient";
import {getRoleHome} from "./utils/routeConfig";


const PublicRoute = () => {
    const checkAuth = useMemo(() => {
        return (accessToken) => {
            return accessToken;
        };
    }, []);

    const role           = getUserRole();
    const normalizedRole = role?.toLowerCase().replace(/\s+/g, "_");
    const home           = getRoleHome(normalizedRole);

    const accessToken = localStorage.getItem("auth_token");

    return checkAuth(accessToken) ?
        <Navigate to={home} replace />  : <Outlet />;
};

export default PublicRoute;


